import Appsignal from '@appsignal/javascript';

let appsignalInstance = null;

if (devex?.data?.appsignalFrontendApiKey) {
  appsignalInstance = new Appsignal({
    key: devex?.data?.appsignalFrontendApiKey,
    namespace: 'angularjs',
  });
}

angular.module('services.ErrorReportingService', [])
  .factory('$exceptionHandler', [
    function() {
      return function errorCatcherHandler(exception) {
        if (appsignalInstance) {
          appsignalInstance.send(exception);
        }
        // eslint-disable-next-line no-console
        console.error(exception);
      };
    }
  ]);
